import React, { useState } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import IconButton from '../common/elements/IconButton';
import Button from '../common/elements/Button';
import Traveler from './Traveler';
import travelersApi from '../../services/api/travelers';
import NewTraveler from '../assurance/simulation/travelers/NewTraveler';
import Card from '../common/layout/Card';
import CloseIcon from '../../../public/static/images/icons/close.svg';

const BREAKPOINT = '880px';
const styles = css`
  .traveler {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
  }
  @media (min-width: ${BREAKPOINT}) {
    .traveler {
      flex-direction: row;
    }
  }
  .travelers {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
  }
  .close-new-traveler {
    align-self: flex-end;
    background: none;
    border: none;
  }
`;

const dynamicStyles = css.resolve`
  .trash-icon {
    margin: 18px 0 0 0;
  }
  @media (min-width: ${BREAKPOINT}) {
    .trash-icon {
      margin: 0 0 0 18px;
    }
  }
  @media (min-width: ${BREAKPOINT}) {
    .add-button {
      max-width: 40%;
      margin: 20px auto;
    }
  }
  .new-traveler {
    border-radius: 16px;
    padding: 12px;
    box-sizing: border-box;
  }

  @media (min-width: ${BREAKPOINT}) {
    .new-traveler {
      margin-right: 68px;
      padding: 24px;
      width: auto;
    }
  }
`;

const TravelersList = ({ travelers, countries }) => {
  const [travelersList, setTravelersList] = useState(travelers);
  const [openForm, setOpenForm] = useState(false);
  const [error, setError] = useState(false);

  const removeTraveler = async travelerId => {
    const response = await travelersApi.remove(travelerId);
    if (response.ok) {
      setError(false);
      const updatedTravelersList = travelersList.filter(
        traveler => traveler.id !== travelerId
      );
      setTravelersList(updatedTravelersList);
    } else {
      setError(true);
    }
  };

  const cancelNewTraveler = () => {
    setOpenForm(null);
  };

  const addNewTraveler = () => {
    setOpenForm(true);
  };

  const saveTraveler = async traveler => {
    await travelersApi.add(traveler);
    const updatedTravelers = [...travelersList, traveler];
    setTravelersList(updatedTravelers);
    setOpenForm(false);
  };

  return (
    <>
      <ul className="travelers">
        {travelersList.map(traveler => (
          <li className="traveler" key={traveler.id}>
            <Traveler traveler={traveler} />
            {error ? (
              <p className="error">
                Une erreur technique a empêché la supression de ce voyageur.
                Veuillez essayer à nouveau. Si l’erreur persiste, contactez le
                support.
              </p>
            ) : null}
            <IconButton
              className={classnames(dynamicStyles.className, 'trash-icon')}
              icon="trash"
              size="m"
              alt="Supprimer le profil"
              onClick={() => removeTraveler(traveler.id)}
            />
          </li>
        ))}
      </ul>
      {openForm ? (
        <Card className={classnames(dynamicStyles.className, 'new-traveler')}>
          <button className="close-new-traveler" onClick={cancelNewTraveler}>
            <CloseIcon /> <span className="sr-only">Fermer</span>
          </button>
          <NewTraveler onAdd={saveTraveler} countries={countries} />
        </Card>
      ) : (
        <Button
          className={classnames('add-button', dynamicStyles.className)}
          onClick={() => addNewTraveler()}
        >
          Ajouter un nouveau voyageur
        </Button>
      )}
      <style jsx>{styles}</style>
      {dynamicStyles.styles}
    </>
  );
};

TravelersList.propTypes = {
  travelers: PropTypes.array
};

export default TravelersList;
